import { Form, Link, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Button,Modal } from "antd";
import {Input} from "@vds/inputs"
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import RolesPermission from "./RolesPermission";
import { createRolesList, updateRoleList, validateRolesNameAPI } from "../../../global/utility/Utils";
import { DeleteRolesModal } from "../RolesModal";
import { deleteRoleEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../global/constants/inputLimits";
import ValidationIcon, {
  getInputClassNamesUser,
  ErrorMessage,
} from "../../../global/components/ValidationIcon";
import ToastNotification from "../../../global/components/ToastNotification";

const CreateRole = ({visible, closePopup,state, onUserCreated}) => {
  let navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
 // let { state } = useLocation();

  const defaultPermission = {
    alarms: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    assets: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    apiDocumentation: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    devices: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    insights: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    organizations: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    Locations: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    roles: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    },
    users: {
      view: false,
      create: false,
      edit: false,
      delete: false,
      download: false,
      configure: false,
    }
  };

  const [permissions, setPermissions] = useState(defaultPermission);
  const [dataList, setDataList] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showDeleteRole, setShowDeleteRole] = useState(false);
  const [deleteRuleConfirmed, setDeleteRuleConfirmed] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationProps, setNotificationProps] = useState({});
  const [typeNotific, setTypeNotific] = useState("error");
  const [msgNotific, setMsgNotific] = useState("");
  const [formData, setFormData] = useState({
    roleName: "",
    description: "",
  });

  const [errors, setErrors] = useState({
    roleName: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    let tempErrors = { ...errors };
    switch (name) {
      case "roleName":
        tempErrors.roleName = value ? "" : "Role Name is required";
        break;
      default:
        break;
    }
    setErrors(tempErrors);
  };
  const handleClose = () => {
    setShowNotification(false);
  };
  const handleSubmit = async () => {
  let tempErrors = { ...errors };
  tempErrors.roleName = formData.roleName ? "" : "Role Name is required";

  // Check for initial errors
  if (Object.values(tempErrors).some((x) => x !== "")) {
    setErrors(tempErrors);
    return; 
  }

  if (selectedItem) {
    const isNameChanged = selectedItem?.roleName !== formData?.roleName;
    if (isNameChanged) {
      const response = await validateRolesNameAPI(formData?.roleName);
      if (response?.status !== 200) {
        setErrors({ ...tempErrors, roleName: "Role Name already exists" });
        return; 
      }
    }
  } else {
    // Creating new role
    const response = await validateRolesNameAPI(formData?.roleName);
    if (response?.status !== 200) {
      setErrors({ ...tempErrors, roleName: "Role Name already exists" });
      return; 
    }
  }
  if (selectedItem) {
    // Update existing role
    const updateResponse = await updateRoleList({ ...formData, permissions });
    if (updateResponse?.message) {
      setNotificationProps({
        type: 'success',
        message: 'Edit Role',
        description: `Role "${selectedItem?.roleName}" updated successfully`,
        duration: 1,
        style: { backgroundColor: '#d4edda', color: '#155724' },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
        onUserCreated();
      }, 1000);
      setSelectedItem(null);
    } else {
      setNotificationProps({
        type: 'error',
        message: 'Edit Role',
        description: `Role "${selectedItem?.roleName}" update failed`,
        duration: 1,
        style: { backgroundColor: '#FFECE0', color: '#155724' },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    }
  } else {
    // Create new role
    const newItem = { id: Date.now(), ...formData, permissions };
    const createResponse = await createRolesList(newItem);
    if (createResponse?.message) {
      setDataList([...dataList, newItem]);
      setNotificationProps({
        type: 'success',
        message: 'Add role',
        description: `Role "${createResponse?.name}" created successfully`,
        duration: 1,
        style: { backgroundColor: '#d4edda', color: '#155724' },
      });
      setShowNotification(true);
      setTimeout(() => {
        onUserCreated();
        setShowNotification(false);
      }, 1000);
      setFormData({
        roleName: "",
        description: ""
      });
    } else {
      setNotificationProps({
        type: 'error',
        message: 'Add Role',
        description: `Role creation failed`,
        duration: 1,
        style: { backgroundColor: '#FFECE0', color: '#155724' },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    }
  }
};

  const deleteRole = () => {
    setShowDeleteRole(true);
  };

  const onConfirm = async () => {
    setDeleteRuleConfirmed(true);
    setShowDeleteRole(false);

    const response = await fetch(deleteRoleEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountname: sessionStorage.getItem("accountId"),
        roleId: state?.id,
      }),
    });
    const responseJson = await response;
    const deleteRoleRsp = response;
    if (deleteRoleRsp) {
      if (deleteRoleRsp?.status===200||deleteRoleRsp?.status===204) {
        setFormData({
          roleName: "",
          description: ""
        });
        setTypeNotific("success");
        setMsgNotific("Roles was deleted successfully");
        setShowNotification(true);
        setTimeout(() => {
          navigate("/roles");
        }, 1000); 
      }else if(deleteRoleRsp?.status===500 && deleteRoleRsp?.error === "conflict_error"){
        setTypeNotific("error");
        setMsgNotific("Role cannot be deleted as there are active users associated with this role");
        setShowNotification(true);
      }else{
        setTypeNotific("error");
        setMsgNotific("Roles deleted failed");
        setShowNotification(true);
      }
    }
  };
  const onExit = () => {
    setDeleteRuleConfirmed(false);
    setShowDeleteRole(false);
    navigate(-1);
  };
  useEffect(() => {
    if (state) {
      if (user?.role?.permissions?.roles?.edit) {
        setSelectedItem({
          roleName: state?.name,
          description: state?.description,
        });
        const length = state?.permissions ? Object.keys(state.permissions).length : 0;
        setPermissions(length !==0? state?.permissions:defaultPermission);
        setFormData({
          roleName: state?.name,
          description: state?.description,
          id: state?.id,
        });
      } else if (!user?.role?.permissions?.roles?.create) {
        navigate("/roles");
      }
    } else if (!user?.role?.permissions?.roles?.create) {
      navigate("/roles");
    }
  }, [state, user, navigate]);

  return (
    <>
      <Modal
      data-testid="create-role-modal"
      title=""
      open={visible}
      onCancel={() => closePopup(false)}
      footer={[
        <Grid2
          data-testid="create-role-modal-grid"
          container
          marginTop={1}
          marginBottom={2}
          spacing={1}
          columns={{ xs: 12 }}
        >
          <Grid2 item xs={12} sm={2} md={2} lg={2}>
            <div className="mb-3">
              <Button
                data-testid="add-edit-roles-cancel-button"
                className="custom-button-cancel"
                type="default"
                onClick={() => closePopup(false)}
                shape="round"
                style={{ fontWeight: "bold", width: "100%" }}
                size={"large"}
              >
                Cancel
              </Button>
            </div>
          </Grid2>
          <Grid2 item xs={12} sm={8} md={8} lg={8}>
            </Grid2>

          <Grid2 item xs={12} sm={2} md={2} lg={2}>
            <div className="mb-3">
              <Button
                data-testid="add-edit-roles-save-button"
                className="custom-button-save"
                type="primary"
                onClick={handleSubmit}
               shape="round"
                style={{
                  width: "100%",
                  backgroundColor: "black",
                  color: "white",
                  fontWeight: "bold",
                }}
                size={"large"}
              >
                 {state !== null ? "Save" : "Add"}
              </Button>
            </div>
          </Grid2>
        </Grid2>,
      ]}
      width={950}
    >
       {showNotification && (
          <ToastNotification
            type={notificationProps.type}
            message={notificationProps.message}
            description={notificationProps.description}
            duration={notificationProps.duration}
            style={notificationProps.style}
          />
        )}
      <div style={{ marginBottom: "10px" }}>
       
        <h2 className={"font-face-vzb page-heading-user"}>
          {state !== null ? "Edit role" : "Add role"}
        </h2>
        <br />
      </div>
      <Form>
        <Grid2
          container
          marginTop={1}
          marginBottom={2}
          spacing={1}
          columns={{ xs: 12 }}
        >
            <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
              <div className="mb-4">
                <label className="input-label-user">Role Name</label>
                <div className="input-container">
                  <Input
                    type="text"
                    id="roleName"
                    name="roleName"
                    value={formData.roleName}
                    onChange={(e) => handleChange(e)}
                    maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
                    error={!!errors.roleName || !!getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData.roleName)}
                    errorText={errors.roleName || getCharLimitMsgIfExceeded("CATEGORY_TEXT", formData.roleName) || ''}
                    required
                  />
                </div>
              </div>
              <div className="mb-4">
                <label className="input-label-user">Description</label>

                <Input
                  name="description"
                  id="description"
                  value={formData.description}
                  maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXTAREA}
                  onChange={(e) => handleChange(e)}
                  required={false}
                  error={!!getCharLimitMsgIfExceeded("CATEGORY_TEXTAREA", formData.description)}
                  errorText={
                    getCharLimitMsgIfExceeded("CATEGORY_TEXTAREA", formData.description) ||
                    ""
                  }
                  width="100%"
                />
              </div>
            </Grid2>
          <Grid2 item xs={12} sm={12} md={12} lg={12} direction="row">
            <div className="mb-4">
            <label className="font-face-vzw">Permissions</label>
              <div className="input-container">
                <RolesPermission
                  existingPermissions={permissions}
                  permissions={permissions}
                  setPermissions={setPermissions}
                />
              </div>
            </div>
          </Grid2>
        </Grid2>
        <DeleteRolesModal
          showDeleteRole={showDeleteRole}
          setShowDeleteRole={setShowDeleteRole}
          message="Are you sure you want to delete the Role"
          title="Delete Role"
          onConfirm={onConfirm}
          onExit={onExit}
        />
        <div xs={2} sm={2} md={2} lg={6}>
          
        </div>
      </Form>
      </Modal>
    </>
  );
};

export default CreateRole;